export default "__VITE_ASSET__Diq2jCR___"